import * as React from "react";
import { formatMessage } from "lib/globalize-util";
import LinkIcon from "components/icons/link-icon";
import { merge, $ } from "glamor";
import { DATATEST } from "constants/integration";

interface IProps {
    item: any;
    onLinkProductToItem?: (event) => void;
}

export const LinkProducts: React.FunctionComponent<IProps> = ({ item, onLinkProductToItem }) => {
    const styles = React.useMemo(() => {
        return merge(
            {
                width: "100%",
                height: "40px",
                margin: "0px 8px 30px 8px",
                backgroundColor: "#f5f5f5",
            },
            $(" .linkImage", {
                width: "50%",
                margin: "0 auto",
                lineHeight: "40px",
                cursor: "pointer",
                fontWeight: "bold",
                color: "#2d2d2d",
                textAlign: "center",
            })
        );
    }, []);

    const muiStyles = React.useMemo(() => {
        return {
            linkIcon: {
                position: "relative",
                top: "6px",
                marginLeft: "16px",
            },
        };
    }, []);

    const isSMU = item ? !item.getIn(["fields", "_product_id", "string_value"], false) : true;

    if (!isSMU) {
        return null;
    }

    return (
        <div {...styles}>
            <div
                data-test={DATATEST.ASSORTMENTS.CDP.LINK_PRODUCT_BTN}
                onClick={onLinkProductToItem ? onLinkProductToItem : null}
                className="linkImage"
            >
                {formatMessage("Link to a product")}
                <LinkIcon style={muiStyles.linkIcon} />
            </div>
        </div>
    );
};
